import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/jifenshangc_icon.png'
import _imports_1 from '@/assets/images/huodongzhongxin_icon.png'
import _imports_2 from '@/assets/images/zhuboxiangguan_icon.png'
import _imports_3 from '@/assets/images/guankanlishi_icon.png'
import _imports_4 from '@/assets/images/me_icon_01.png'
import _imports_5 from '@/assets/images/me_icon_02.png'
import _imports_6 from '@/assets/images/me_icon_06.png'
import _imports_7 from '@/assets/images/me_icon_03.png'
import _imports_8 from '@/assets/images/me_icon_04.png'
import _imports_9 from '@/assets/images/huanc.png'
import _imports_10 from '@/assets/images/me_icon_07.png'
import _imports_11 from '@/assets/images/me_icon_05.png'


const _withScopeId = n => (_pushScopeId("data-v-385eec65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "topbox" }
const _hoisted_3 = { class: "avatarBox" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "namebox" }
const _hoisted_7 = { class: "name van-ellipsis" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "userid" }
const _hoisted_10 = {
  key: 0,
  class: "userid"
}
const _hoisted_11 = {
  key: 1,
  class: "userid",
  style: {"color":"#f3703b"}
}
const _hoisted_12 = {
  key: 0,
  class: "subzb"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "iconbox" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_19 = { class: "iconList" }
const _hoisted_20 = { class: "left" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_22 = { class: "right" }
const _hoisted_23 = { class: "left" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_25 = { class: "right" }
const _hoisted_26 = { class: "left" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_28 = { class: "right" }
const _hoisted_29 = { class: "left" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_31 = { class: "right" }
const _hoisted_32 = { class: "left" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_34 = { class: "right" }
const _hoisted_35 = { class: "left" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_37 = { class: "right" }
const _hoisted_38 = { class: "left" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_40 = { class: "right" }
const _hoisted_41 = { class: "iconList" }
const _hoisted_42 = { class: "left" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_44 = { class: "right" }
const _hoisted_45 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!$setup.isYk)
            ? (_openBlock(), _createBlock(_component_van_image, {
                key: 0,
                round: "",
                width: "80",
                height: "80",
                src: $setup.user.avatar
              }, null, 8 /* PROPS */, ["src"]))
            : (_openBlock(), _createBlock(_component_van_image, {
                key: 1,
                round: "",
                width: "80",
                height: "80",
                src: $setup.noLoginAvatar,
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onCickLogin()))
              }, null, 8 /* PROPS */, ["src"])),
          (!$setup.isYk)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push('/Setting'))),
                src: $setup.editeIcon,
                class: "bianji",
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", {
          class: "userinfo",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.onCickLogin()))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString($setup.isYk ? $setup.t("me.onLogin") : $setup.user.nickName), 1 /* TEXT */),
              (!$setup.isYk)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $setup.VipLevelImg[$setup.level],
                    alt: ""
                  }, null, 8 /* PROPS */, _hoisted_8))
                : _createCommentVNode("v-if", true)
            ]),
            (!$setup.isQD)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "qd",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.serban('积分商城')), ["stop"]))
                }, _toDisplayString(_ctx.$t("me.sign")), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "yiqd",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.serban('积分商城')), ["stop"]))
                }, _toDisplayString(_ctx.$t("me.onsign")), 1 /* TEXT */))
          ]),
          _createElementVNode("div", _hoisted_9, "ID:" + _toDisplayString($setup.user.fid), 1 /* TEXT */),
          (!$setup.isYk)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('me.signname')) + ":" + _toDisplayString($setup.user.sign == "" ? $setup.t("me.sigin1") : $setup.user.sign), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("me.dl")) + " / " + _toDisplayString(_ctx.$t("me.tipsregst")), 1 /* TEXT */))
        ])
      ]),
      ($setup.matchAD)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("img", {
              src: $setup.matchAD.img,
              alt: "",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.toLocationBrowser($setup.matchAD.url)))
            }, null, 8 /* PROPS */, _hoisted_13)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_14, [
        (!$setup.offStore)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "itemIcon",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.serban('积分商城')))
            }, [
              _hoisted_15,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.jfsc")), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createElementVNode("div", {
          class: "itemIcon",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.router.push('/activity')))
        }, [
          _hoisted_16,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("im.activity")), 1 /* TEXT */)
        ], 512 /* NEED_PATCH */), [
          [_vShow, !$setup.is_lb]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "itemIcon",
          onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.serban('关注主播')))
        }, [
          _hoisted_17,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.zbxg")), 1 /* TEXT */)
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.is_show_host]
        ]),
        _createElementVNode("div", {
          class: "itemIcon",
          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.serban('观看历史')))
        }, [
          _hoisted_18,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.gkls")), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", {
          class: "itemList",
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.onCickLogin()))
        }, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.wddj")), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", null, _toDisplayString($setup.vipName), 1 /* TEXT */),
            _createVNode(_component_van_icon, {
              class: "icon",
              name: "arrow",
              color: "#898989",
              size: "10"
            })
          ])
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "itemList",
          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.router.push('/inviteaward')))
        }, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.yqhy")), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.yqhydjf")), 1 /* TEXT */),
            _createVNode(_component_van_icon, {
              class: "icon",
              name: "arrow",
              color: "#898989",
              size: "10"
            })
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.is_show_host]
        ]),
        (!$setup.is_lb)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "itemList",
              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.toServer()))
            }, [
              _createCommentVNode(" 在线客服 "),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.zxkf")), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createCommentVNode(" <span>{{ $t(\"me.yqhydjf\") }}</span> "),
                _createVNode(_component_van_icon, {
                  class: "icon",
                  name: "arrow",
                  color: "#898989",
                  size: "10"
                })
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (!$setup.is_lb)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "itemList",
              onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.toProposal()))
            }, [
              _createCommentVNode(" 意见反馈 "),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.yjfk")), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_van_icon, {
                  class: "icon",
                  name: "arrow",
                  color: "#898989",
                  size: "10"
                })
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: "itemList",
          onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.serban('关于我们')))
        }, [
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.gywm")), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('版本')) + " " + _toDisplayString($setup.channelId + "." + $setup.version), 1 /* TEXT */),
            _createVNode(_component_van_icon, {
              class: "icon",
              name: "arrow",
              color: "#898989",
              size: "10"
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "itemList",
          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.huanc()))
        }, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("clearCache")), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("span", null, _toDisplayString($setup.size) + "KB", 1 /* TEXT */),
            _createVNode(_component_van_icon, {
              class: "icon",
              name: "arrow",
              color: "#898989",
              size: "10"
            })
          ])
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "itemList",
          onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.router.push('/delaccount')))
        }, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.zxzh")), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_van_icon, {
              class: "icon",
              name: "arrow",
              color: "#898989",
              size: "10"
            })
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, $setup.is_show_host]
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", {
          class: "itemList",
          onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.serban('设置')))
        }, [
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("me.setting")), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_van_icon, {
              class: "icon",
              name: "arrow",
              color: "#898989",
              size: "10"
            })
          ])
        ])
      ]),
      ($setup.h5Foot !== '')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            innerHTML: $setup.h5Foot,
            class: "h5Foot"
          }, null, 8 /* PROPS */, _hoisted_45))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" <div class=\"box-cent\">\n      <div class=\"box-serv\" v-if=\"!offStore\">\n        <div class=\"box-serv-en\" @click=\"serban('积分商城')\">\n          <div class=\"box-serv-en-left\">\n            <van-image :src=\"icon1\" />\n          </div>\n          <div class=\"box-serv-en-cententr\">\n            <p>积分商城</p>\n          </div>\n          <div class=\"box-serv-en-right\">\n            <van-icon name=\"arrow\" />\n          </div>\n        </div>\n      </div>\n      <div class=\"box-serv\">\n        <div class=\"box-serv-en\" @click=\"serban('关注主播')\">\n          <div class=\"box-serv-en-left\">\n            <van-image :src=\"icon2\" />\n          </div>\n          <div class=\"box-serv-en-cententr\">\n            <p>关注主播</p>\n          </div>\n          <div class=\"box-serv-en-right\">\n            <van-icon name=\"arrow\" />\n          </div>\n        </div>\n        <div class=\"box-serv-en\" @click=\"serban('观看历史')\">\n          <div class=\"box-serv-en-left\">\n            <van-image :src=\"icon3\" />\n          </div>\n          <div class=\"box-serv-en-cententr\">\n            <p>观看历史</p>\n          </div>\n          <div class=\"box-serv-en-right\">\n            <van-icon name=\"arrow\" />\n          </div>\n        </div>\n      </div>\n      <div class=\"box-serv\">\n        <div class=\"box-serv-en\" @click=\"serban('联系客服')\">\n          <div class=\"box-serv-en-left\">\n            <van-image :src=\"icon4\" />\n          </div>\n          <div class=\"box-serv-en-cententr\">\n            <p>联系客服</p>\n          </div>\n          <div class=\"box-serv-en-right\">\n            <van-icon name=\"arrow\" />\n          </div>\n        </div>\n        <div class=\"box-serv-en copyurl\" @click=\"copyjsurl('copyurl', Platform.downUrl)\">\n          <div class=\"box-serv-en-left\">\n            <van-image :src=\"icon5\" />\n          </div>\n          <div class=\"box-serv-en-cententr\">\n            <p>邀请好友</p>\n          </div>\n          <div class=\"box-serv-en-right\">\n            <van-icon name=\"arrow\" />\n          </div>\n        </div>\n        <div class=\"box-serv-en scrsa\" @click=\"serban('关于我们')\">\n          <div class=\"box-serv-en-left\">\n            <van-image :src=\"icon6\" />\n          </div>\n          <div class=\"box-serv-en-cententr\">\n            <p>关于我们</p>\n          </div>\n          <div class=\"box-serv-en-right\">\n            <van-icon name=\"arrow\" />\n          </div>\n        </div>\n      </div>\n      <div class=\"box-serv\">\n        <div class=\"box-serv-en\" @click=\"serban('设置')\">\n          <div class=\"box-serv-en-left\">\n            <van-image :src=\"icon7\" />\n          </div>\n          <div class=\"box-serv-en-cententr\">\n            <p>设置</p>\n          </div>\n          <div class=\"box-serv-en-right\">\n            <van-icon name=\"arrow\" />\n          </div>\n        </div>\n      </div>\n    </div> ")
    ]),
    _createCommentVNode(" <layout /> ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}